<template>
    <ul class="optionset">
        <li v-for="(option, index) in question.options" :key="index" class="optionset__option">
            <input
                :id="`answer-${index}`"
                type="radio"
                v-model="selection"
                :value="index"
                required
                name="option"
            />
            <label
                :for="'answer-' + index"
                class="optionset__option-label"
                v-bind:class="{'optionset__option-label--active': (selection === index) }">

                <span>{{ option.text }}</span>
            </label>
        </li>
    </ul>
</template>

<script>
export default {
    name: "OptionsetField",
    props: {
        question: Object
    },
    data() {
        return {
            selection: null
        }
    },
    mounted() {
    },
    methods: {
        getValue() {
            return this.selection;
        },
        getValid() {
            return (this.selection);
        }
    }
}
</script>

<style scoped lang="stylus">


.optionset {
    list-style: none;
    margin: 0 0 2em;
    padding: 0;
    display: flex;
    flex-shrink: 0;
    flex-basis: auto;
    width: 100%;
    box-sizing: border-box;
    align-self: stretch;
    flex-direction: column;
    justify-content: center;

    &__option {
        display: flex;
        justify-content: space-evenly;
        flex-basis: 100%;
    }

    &, * {
        cursor: pointer;
    }

    input {
        display: none;
    }

    &__option-label {
        border: 2px solid brand-yellow;
        padding: 1.7em 1.5em 1.5em;
        border-radius: 0.8em;
        margin: 0.5em;
        display: flex;
        flex-shrink: 0;
        flex-basis: auto;
        max-width: 100%;
        width: calc(100% - 1em);
        align-items: center;
        align-self: stretch;
        justify-content: center;
        font-weight: 700;
        font-size: 1.1em;
        box-sizing: border-box;
        line-height: 1.4;
        transition: 0.1s ease-in-out;
        transition-property: background-color, color, border-color, transform, box-shadow;
        background-color: white;
        user-select none;

        span {
            display: block;
            max-width: 100%;
        }

        &:hover {
            background: brand-blue;
            color: white;
            border-color: brand-blue;
            transform: scale(1.03);
        }

        &--active,
        &--active:hover,
        &:active {
            background: brand-blue;
            color: white;
            border-color: white;
            box-shadow: 0 0.2em 1em rgba(0, 0, 0, 0.4), inset 0 0 2em rgba(0, 0, 0, 0.2);
            transform: scale(1.03);
        }

        &--active {
            //animation: optionset-select 0.5s linear forwards;
        }
    }
}

@media (min-width: 1200px) {
    .optionset {
        flex-direction: row;

        &__option-label {
            max-width: 24em;
            font-size: 1.1em;
            min-height: 250px;
        }
    }
}

@media (min-width: 1600px) {
    .optionset {
        &__option-label {
            font-size: 1.2em;
        }
    }
}


    @keyframes optionset-select {
        10%, 75% {
            background: lighten(brand-blue, 10);
        }

        60%, 100% {
            background: brand-blue;
        }
    }
</style>